import i18next from 'i18next'
import {
  notPescotarian,
  notVegan,
  notVegetarian,
} from '../../../utils/dietaryWishesAndAllergens'
import { SearchTab } from '../search/searchState'

export type CategoriesFilter = {
  category?: string
  subcategory?: string
  ingredient?: string
}

export type TopFilters = {
  techniques?: string[]
  appearances?: string[]
  textures?: string[]
  allergens?: string[]
  types?: string[]
}

export type Filters = {
  term?: string,
  categoriesFilter?: CategoriesFilter,
  topFilters?: TopFilters,
  page?: number,
  pageSize? : number,
  language? : string,
  includePyramid?: boolean,
  searchTab? : SearchTab
}

const filterParams = ({
  term,
  categoriesFilter = {},
  topFilters = {},
  page,
  pageSize,
  language,
  searchTab,
  includePyramid = false
}: Filters) => {
  const { category, subcategory, ingredient } = categoriesFilter;
  const { techniques = [], appearances = [], textures = [], allergens = [], types = [] } = topFilters;
  const pyramidAllergens = includePyramid 
    ? allergens.includes(notVegan)
      ? allergens.concat(notPescotarian, notVegetarian)
      : allergens.includes(notVegetarian)
      ? allergens.concat(notPescotarian)
      : allergens
    : allergens

  const ifNotUndefined = (
    whenString: (string: string) => string,
    string?: string
  ) => (string === undefined ? '' : whenString(string))

  const termParam = ifNotUndefined(
    (term: string) => `term=${term}`,
    term
  )

  const categoryParam = ifNotUndefined(
    (category: string) => `category=${category}`,
    category
  )
  const subcategoryParam = ifNotUndefined(
    (subcategory: string) => `subcategory=${subcategory}`,
    subcategory
  )
  const ingredientParam = ifNotUndefined(
    (ingredient: string) => `ingredient=${ingredient}`,
    ingredient
  )

  const techniquesParams = techniques.map(
    (technique) => `technique=${technique}`
  )
  const appearancesParams = appearances.map(
    (appearance) => `appearance=${appearance}`
  )
  const texturesParams = textures.map(
    (texture) => `texture=${texture}`
  )
  const allergensParams = pyramidAllergens.map(
    (allergen) => `allergen=${allergen}`
  )
  const typesParams = types.map(
    (type) => `type=${type}`
  )

  const pageParam = ifNotUndefined(
    (page: string) => `page=${page}`,
    page?.toString()
  )

  const pageSizeParam = ifNotUndefined(
    (pageSize: string) => `pageSize=${pageSize}`,
    pageSize?.toString()
  )

  const languageParam = ifNotUndefined(
    (language: string) => `language=${language}`,
    language
  )

  const searchTabParam = ifNotUndefined(
    (searchTab: string) => `tab=${searchTab}`,
    searchTab
  )

  return [termParam, categoryParam, subcategoryParam, ingredientParam, pageParam, pageSizeParam, languageParam, searchTabParam]
    .concat(techniquesParams)
    .concat(appearancesParams)
    .concat(texturesParams)
    .concat(allergensParams)
    .concat(typesParams)
    .filter((p) => p !== '')
    .join('&')
}

export const filteredUrl = (baseUrl: string) => 
  (filter: Filters) => {
    const params = filterParams(filter);
    return `${baseUrl}${params === '' ? '' : `?${params}`}`
  }